import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardCollectionStepperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardCollectionStepperTemplate';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import Layout from './Layout';

const styles = () => ({
  root: {},
});
const InvestmentObjectivesAccountReviewTemplate = ({
  className,
  classes,
}) => {
  const { pageContentResource: resource } = usePageContentContext();
  const collection = resource.attr('accountObjectives');
  return (
    <WizardCollectionStepperTemplate
      className={classNames(className, classes.root)}
      layout={Layout}
      collection={collection}
      metaOverrideSet={BaseOverride}
      template={'InvestmentObjectivesAccountReview'}
    />
  );
};

InvestmentObjectivesAccountReviewTemplate.defaultProps = {
  className: '',
};

InvestmentObjectivesAccountReviewTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InvestmentObjectivesAccountReviewTemplate);
